<template>
	<div class="main-banner-star-box">
		<!-- 上半部分 -->
		<!-- <ul class="main_banner_star">
            左侧链接
            <li class="hidden-xs hidden-sm">
                <ul class="left-nav">
                    <li v-for="item of LeftNav" :key="item.id">
                        <a href="javascript:;">
                            <img :src="require('@/assets/'+item.src)" alt="">
                            <span>{{item.name}}</span>
                        </a>
                    </li>
                </ul>
            </li>
            右侧三个图标链接
            <li v-for="item of star" :key="item.id">
                <a href="#" v-if="item.advertising_image">
                    <img :src="item.advertising_image" :title="item.title">
                </a>
            </li>
        </ul> -->
		<!-- 下半部分 -->
		<div class="main-banner-hot">
			<!-- 标题 -->
			<div class="main-banner-hot-title">{{$t("message.main.hot")}}</div>
			<!-- 商品区域 -->
			<carousel class="main-banner-hot-carousel" :minSwipeDistance="40" :scrollPerPage="true" :speed="2000"
				:perPageCustom="[[500,5]]" :loop="true" :paginationEnabled="false" :navigationEnabled="true"
				navigationPrevLabel="<" navigationNextLabel=">">
				<slide v-for="(item,index) of hot" :key="index">
					<div :class="[
					        'center-goods-box',
					        {'hover-box': enter_index === index}
					    ]" @mouseenter="handleMove(index)" @mouseleave="handleMove(-1)">
						<img-main-hot :item="item" :hotBorder="[hotSaleBorder[index]]">
						</img-main-hot>
						<!-- 收藏按钮 -->
						<div v-if="power.includes(17) || power.includes(0) || power.includes(111)" :class="[
					            'center-goods-collection',
					            {'is-collection':item.collection>0}
					        ]">
							<a href="javascript:;" @click="handleCollection(item)">
								<i class="glyphicon glyphicon-heart-empty"></i>
							</a>
						</div>
					</div>
				</slide>
			</carousel>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions,
		mapGetters
	} from 'vuex'

	export default {
		data() {
			return {
				enter_index: -1,
				LeftNav: [{
						"src": "img/images/fenqubankuai.png",
						"name": "分区板块"
					},
					{
						"src": "img/images/fenqubankuai.png",
						"name": "集团采购"
					},
					{
						"src": "img/images/fenqubankuai.png",
						"name": "分区板块"
					},
					{
						"src": "img/images/fenqubankuai.png",
						"name": "分区板块"
					},
					{
						"src": "img/images/fenqubankuai.png",
						"name": "托管货物"
					},
					{
						"src": "img/images/fenqubankuai.png",
						"name": "分区板块"
					},
				],
				hotSaleItem: [],
				hotSaleBorder: [{
						"border-top": "1px solid #ffac13"
					},
					{
						"border-top": "1px solid #83c44e"
					},
					{
						"border-top": "1px solid #2196f3"
					},
					{
						"border-top": "1px solid #e53935"
					},
					{
						"border-top": "1px solid #00c0a5"
					},
					{
						"border-top": "1px solid #ffac13"
					},
					{
						"border-top": "1px solid #83c44e"
					},
					{
						"border-top": "1px solid #2196f3"
					},
					{
						"border-top": "1px solid #e53935"
					},
					{
						"border-top": "1px solid #00c0a5"
					},
				]
			}
		},
		computed: {
			...mapState({
				star: state => state.banner.star,
				hot: state => state.banner.hot,
				power: state => state.user.power,
			}),
			...mapGetters([
				'powerPrice',
			])
		},
		methods: {
			...mapActions([
				"requestCollection",
				"getHot"
			]),
			handleMove(val) {
				this.enter_index = val;
			},
			handleCollection(goods) { // 收藏操作
				// console.log(goods)
				let {
					goods_id,
					goods_sn,
					goods_name
				} = goods;
				this.requestCollection({
					goods_id,
					goods_sn,
					goods_name
				}).then((res) => {
					if (res == 1) {
						this.$message({
							showClose: true,
							message: this.$t("message.plist.collection3"),
							type: 'success'
						})
						this.getHot();
						
					} else if (res == 3) {
						this.$message({
							showClose: true,
							message: this.$t("message.plist.collection4"),
							type: 'success'
						})
						this.getHot();
						
					}
				})
			}
		},
		components: {
			imgMainHot: () => import("@/components/imgMainHot")
		},
	}
</script>

<style scoped>
	/* 商品盒子 */
	.center-goods-box {
		position: relative;
	}
	
	.hover-box>.center-goods-collection {
		z-index: 3;
		opacity: 0.8;
	}
	
	.hover-box>.center-goods-collection:hover {
		background: #ff6700;
	}
	
	/* 收藏盒子 */
	.center-goods-collection {
		position: absolute;
		top: 15px;
		right: 20px;
		width: 50px;
		height: 50px;
		border-radius: 50%;
		background-color: #909399;
		opacity: 0;
		transition: all 0.2s linear;
		z-index: -1;
	}
	
	.center-goods-collection>a {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: block;
		color: #fff;
	}
	
	.center-goods-collection i {
		line-height: normal;
		font-size: 30px;
	}
	
	/* 已收藏样式 */
	.is-collection {
		background-color: transparent !important;
		opacity: 1;
		z-index: 100;
	}
	
	.is-collection>a {
		color: #ff6700;
	}
	
	
	
	/* 组件盒子 */
	.main-banner-star-box {
		margin-top: 16px;
	}

	/*热销产品区域*/
	.main_banner_star {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		height: 150px;
		overflow: hidden;
	}

	/*左侧导航*/
	.main_banner_star>li>.left-nav {
		width: 235px;
		height: 150px;
		display: flex;
		flex-wrap: wrap;
	}

	/**/
	.main_banner_star>li>.left-nav>li {
		width: 78px;
		border: 1px solid #ddd;
		background-color: rgb(95, 87, 80);
	}

	/*鼠标悬停动画*/
	.main_banner_star>li>.left-nav>li:hover {
		border: 1px ridge #ffac13;
	}

	/**/
	.main_banner_star>li>.left-nav>li>a {
		display: block;
		text-align: center;
		margin-top: 20px;
	}

	/**/
	.main_banner_star>li>.left-nav>li>a>img {
		display: block;
		margin: 0 auto;
	}

	.main_banner_star>li>.left-nav>li>a>span {
		color: rgb(205, 202, 200);
		font-size: 11px;
	}

	/*右侧导航*/
	.main_banner_star>li>a>img {
		height: 150px;
		transition: all 1s;
	}

	.main_banner_star>li>a>img:hover {
		transform: scale(1.1);
	}

	/* 热销商品区域 */
	.main-banner-hot {
		margin: 30px 0;
	}

	/* 标题 */
	.main-banner-hot-title {
		margin-bottom: 19px;
		font-size: 24px;
		color: #333;
	}

	/*明星商品轮播图*/
	.main-banner-hot-carousel .VueCarousel-inner>div {
		text-align: center;
		padding-bottom: 10px;
	}

	/* 轮播图左右按钮 */
	.main-banner-hot-carousel>>>.VueCarousel-navigation-prev,
	.main-banner-hot-carousel>>>.VueCarousel-navigation-next {
		top: -50px;
		left: auto;
		padding: 0 !important;
		border: 1px solid #e0e0e0;
		border-radius: 5px;
		width: 50px;
		height: 30px;
		font-weight: bold;
		transform: none;
	}

	/* 悬停样式 */
	.main-banner-hot-carousel>>>.VueCarousel-navigation-prev:hover,
	.main-banner-hot-carousel>>>.VueCarousel-navigation-next:hover {
		color: #fff;
		background: rgba(0, 0, 0, 0.137);
	}

	/* 选中样式 */
	.main-banner-hot-carousel>>>.VueCarousel-navigation-prev:focus,
	.main-banner-hot-carousel>>>.VueCarousel-navigation-next:focus {
		outline: none
	}

	.main-banner-hot-carousel>>>.VueCarousel-navigation-prev {
		right: 70px;
	}

	.main-banner-hot-carousel>>>.VueCarousel-navigation-next {
		right: 0;
	}
</style>
